import script from "./createNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./createNotice.vue?vue&type=script&setup=true&lang=js"

import "./createNotice.vue?vue&type=style&index=0&id=9fd3ec06&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fd3ec06"]])

export default __exports__